import api from './api';

class AppConfigService {
  /**
   * Update mobile app configuration
   * @param {Object} data - App config data
   * @returns {Promise} API response
   */
  async updateMobileAppConfig(data) {
    try {
      const response = await api.post('/api/admin/app-config/mobile-version', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get current mobile app configuration
   * @returns {Promise} API response
   */
  async getMobileAppConfig() {
    try {
      const response = await api.get('/api/app-config/mobile-version');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const appConfigService = new AppConfigService();
export default appConfigService;